export default __webpack_public_path__ + "static/media/Background_00171.26dd6044.png";